import { readCookie } from '@/utils/readCookie';
import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const PartnerProtectedRoute = () => {
    const { pathname } = useLocation();
    const [isReturn, setIsReturn] = useState(true);

    const user = readCookie("user");
    const navigate = useNavigate();


    useEffect(() => {
        if (pathname.includes("/partner") && user && user?._id) {
            setIsReturn(false);
        } else {
            setIsReturn(true);
            navigate("/partner/login");
        }
    }, [pathname, user]);



    if (!isReturn) {
        return <Outlet />;
    }

}

export default PartnerProtectedRoute